import { Button, List } from 'antd';
import { setTwoToneColor } from '@ant-design/icons';
import React from 'react';
import bookingGuideIllustration from '../assets/images/angler-booking-guide.jpg';

export default function HowToBookGuide({ goToCreateAccount }) {
  setTwoToneColor('black');
  return (
    <div className={'gRegular fs-15 txt-center'}>
      <div className={'how-to-book__image__container mg-bottom-20 '}>
        <img
          src={bookingGuideIllustration}
          alt={'swimbooker Angler Booking Guide header'}
          className={'how-to-book__image br20'}
          loading={'lazy'}
        />
      </div>
      <p className={'txt-center gSemiBold fs-17 mg-bottom-25'}>
        Welcome angler! Need assistance getting booked on?
      </p>
      <p className={'txt-center gSemiBold fs-17 mg-bottom-15'}>
        Read on for a step by step guide on how to easily book via Swimbooker.
      </p>
      <List
        className={'how-to-book__list txt-left'}
        size={'large'}
        dataSource={[
          {
            text: (
              <p className={'mg-bottom-0'}>
                Make sure you have created your free swimbooker account. If you
                haven’t,{' '}
                <span
                  className={'cp sb-blue txt-underline'}
                  onClick={goToCreateAccount}
                >
                  click here
                </span>{' '}
                to get started. (Takes less than 20 seconds!)
              </p>
            ),
          },
          {
            text: (
              <p className={'mg-bottom-0'}>
                Once you’ve verified your email, log into your swimbooker
                account. If you are already on a fishery profile, the button at
                the <span className={'gSemiBold'}>bottom of the screen</span>{' '}
                will turn green and say{' '}
                <span className={'gSemiBold'}>‘Book Now’</span>
              </p>
            ),
          },
          {
            text: (
              <p className={'mg-bottom-0'}>
                <span className={'gSemiBold'}>Great! You’re almost there.</span>{' '}
                Select the lake you wish to fish and choose the number of
                anglers and guests in your party. If the lake doesn’t accept
                guests, this option will be greyed out.
              </p>
            ),
          },
          {
            text: (
              <p className={'mg-bottom-0'}>
                Now choose your arrival and departure date.{' '}
                <span className={'gSemiBold'}>Note!</span> If you wish to fish a
                day session, you Only need to select one date. If you wish to
                Fish more than one day, you need to select your the day you
                arrive, and the day you plan on leaving.
              </p>
            ),
          },
          {
            text: (
              <p className={'mg-bottom-0'}>
                Next, the lake time slots will appear below the calendar. Select
                your preferred arrival and departure time slots. Click ‘Next’.
              </p>
            ),
          },
          {
            text: (
              <p className={'mg-bottom-0'}>
                If your lake is a swim booking lake, you will proceed to the
                swim selection step. Select from the available swims{' '}
                <span className={'gSemiBold'}>(the ones that aren’t red!)</span>
                . If there are multiple anglers, you must select a swim for each
                angler.{' '}
                <span className={'gSemiBold'}>
                  Note: For double swims, select the same swim twice until you
                  see an icon with 2 anglers!
                </span>
              </p>
            ),
          },
          {
            text: (
              <p className={'mg-bottom-0'}>
                Once done,{' '}
                <span className={'gSemiBold'}>
                  proceed to the angler details section.
                </span>{' '}
                If you chose a ticket or lake exclusive lake, you will proceed
                directly to this section. Enter all the details for your booking
                including number of rods, angler information and confirm the
                terms of booking.
              </p>
            ),
          },
          {
            text: (
              <p className={'mg-bottom-0'}>
                Proceed to the confirmation step which will reflect the final
                details of your booking. If you are happy to proceed, you simply
                checkout via card payment.
              </p>
            ),
          },
        ]}
        renderItem={(item, i) => (
          <List.Item>
            <List.Item.Meta
              avatar={
                item?.icon ?? (
                  <div className={'box-icon gBold fs-22 pd-20'}>{i + 1}</div>
                )
              }
            />
            <span className={'gMedium fs-15'}>{item.text}</span>
          </List.Item>
        )}
      />
      <p className={'gSemiBold fs-21 uppercase txt-center mg-top-20'}>
        You've booked your session!
      </p>
      <Button
        href={'/contact/anglers'}
        className={
          'how-to-book__button bg-grey gSemiBold brFull white txt-center pd-10 pd-left-30 pd-right-30 mg-top-10 mg-bottom-20 h-fit antd-link-button-override'
        }
      >
        <span className={'fs-16'}>
          If you require further assistance, please click here
        </span>
      </Button>
    </div>
  );
}
